
export function outBounce(n) {
    if (n < (1 / 2.75)) {
        return 7.5625 * n * n;
    } else if (n < (2 / 2.75)) {
        return 7.5625 * (n -= (1.5 / 2.75)) * n + 0.75;
    } else if (n < (2.5 / 2.75)) {
        return 7.5625 * (n -= (2.25 / 2.75)) * n + 0.9375;
    } else {
        return 7.5625 * (n -= (2.625 / 2.75)) * n + 0.984375;
    }
}

export function inBounce(n) {
    return 1 - outBounce(1 - n);
}

export function outCube(n) {
    return --n * n * n + 1;
}

export function linear(n) {
    return n;
}
